module.exports = __webpack_public_path__ + "media/attention.5d1c831a.mp4";